const IconAccount = ({
  fill = "#000000",
  width = "24",
  height = "24",
  className = "",
  viewBox = "0 0 15 21",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className ? className : null}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      data-name="IconAccount"
    >
      <path
        d="M7.50005 9.07143C5.01495 9.07143 2.99996 7.15155 2.99996 4.78585C2.99996 2.41751 5.01495 0.5 7.50005 0.5C9.98602 0.5 12 2.41751 12 4.78585C12 7.15155 9.98602 9.07143 7.50005 9.07143ZM15 17.4317C15 21.5227 0 21.5227 0 17.4317C0 13.3408 3.35787 10.0238 7.4998 10.0238C11.6416 10.0238 15 13.3408 15 17.4317Z"
        fill={fill}
      />
    </svg>
  );
};
export default IconAccount;
